
import Vue from "vue";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import AppMollieTerminalSelect from "@/components/common/MollieTerminalSelect.vue";
import { MollieTerminalService } from "@/services/mollie-terminal-service";
import { MollieTerminal } from "@/utils/mollie-terminal/mollie-terminal";
import { DossierConfigService } from "@/services/dossier-config-service";

export default Vue.extend({
	data(){
		return {
			settings: MollieTerminalService.getSettings(),
			mollieConfig: DossierConfigService.getMollieConfig(),
			terminals: [] as MollieTerminal[],
			saving: false
		};
	},
	computed: {
		show():boolean {
			if (!MollieTerminalService.hasModule()) return false;
			return this.mollieConfig.ConnectedWithMollie;
		}
	},
	methods: {
		async save(){
			if (this.saving) return;
			this.saving = true;
			try {
				MollieTerminalService.setSettings(this.settings);
				this.mollieConfig = await DossierConfigService.saveMollieConfig(this.mollieConfig);
				this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
			} finally {
				this.saving = false;
			}
		}
	},
	async created(){
		if (!this.show) return;
		try {
			this.terminals = await MollieTerminalService.getTerminals();
		} catch (err) {
			this.terminals = [];
		}
	},
	components: {
		AppSelectBankType,
		AppMollieTerminalSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
